import * as React from 'react';

import initBem from 'js/lib/bem';

import { Notification } from '@coursera/coursera-ui';

import type { FormPartsValidationStatus } from 'bundles/compound-assessments/components/form-parts/lib/checkResponsesInvalid';

import _t from 'i18n!nls/compound-assessments';

const bem = initBem('OffPlatform');

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const checkInvalid = (response: unknown): FormPartsValidationStatus | null => null;

type Props = {
  isGraderView?: boolean;
  isQuickGraderContext?: boolean;
};

const OffPlatformView = ({ isGraderView, isQuickGraderContext }: Props) => {
  if (isGraderView || isQuickGraderContext) {
    return null;
  }
  return (
    <div className={bem()}>
      <Notification
        message={_t(
          'Follow the instructions to complete this activity. Your grade will be updated after review by course staff.'
        )}
        type="info"
      />
    </div>
  );
};

export default OffPlatformView;
